












































































































































import { Component, Mixins } from "vue-property-decorator";
import FiltersMixin from "@/mixins/SpecialInitiatives/FiltersMixin";
import TaxonomySelect from "@/components/TaxonomySelect.vue";
import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import VWeekPicker from "@/components/VWeekPicker.vue";
import VMultiSwitcher from "@/components/VMultiSwitcher.vue";
import VSwitchButton from "@/components/VSwitchButton.vue";
import { Route } from "vue-router";
import SpecialInitiatives from "@/services/SpecialInitiavesService";
import SpecialInitiativesSubjectSelector from "@/components/SpecialInitiatives/SpecialInitiativesSubjectSelector.vue";
import SpecialInitiativesTopList from "@/components/SpecialInitiatives/SpecialInitiativesTopList.vue";
import Company from "@/models/Company";
import Brand from "@/models/Brand";
import Product from "@/models/Product";

@Component({
  components: {
    MultiLevelSelect,
    VWeekPicker,
    TaxonomySelect,
    VMultiSwitcher,
    SpecialInitiativesSubjectSelector,
    VSwitchButton,
    SpecialInitiativesTopList,
  },
})
export default class TopInvestors extends Mixins(FiltersMixin) {
  loading = false;
  shareOfVoice = false;
  entriesSpots: Company | Brand | Product[] = [];
  entriesSeconds: Company | Brand | Product[] = [];
  overItem: Company | undefined = new Company({});

  isOver(item: { id: string }) {
    if (this.overItem == undefined) {
      return false;
    }

    return this.overItem.id == item.id;
  }

  onItemOver(item: Company | undefined) {
    this.overItem = item;
  }

  async beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    this.loading = true;
    if (this.forceReloadFromApi) {
      this.forceReloadFromApi = false;
      await this.loadData();
    }
    this.loading = false;
    next();
  }

  async mounted() {
    await this.initFilters();
    await this.loadData();
  }

  private async loadData() {
    this.entriesSpots = [];
    this.entriesSeconds = [];
    if (this.subjectIds.length === 0) {
      return;
    }

    switch (this.granularity) {
      case "company":
        this.filters.unitOfMeasurement = "spots";
        this.entriesSpots = await SpecialInitiatives.loadCompaniesTopInvestors(
          this.filtersForAPI("top_investors")
        );
        this.filters.unitOfMeasurement = "seconds";
        this.entriesSeconds =
          await SpecialInitiatives.loadCompaniesTopInvestors(
            this.filtersForAPI("top_investors")
          );
        break;
      case "brand":
        this.filters.unitOfMeasurement = "spots";
        this.entriesSpots = await SpecialInitiatives.loadBrandsTopInvestors(
          this.filtersForAPI("top_investors")
        );
        this.filters.unitOfMeasurement = "seconds";
        this.entriesSeconds = await SpecialInitiatives.loadBrandsTopInvestors(
          this.filtersForAPI("top_investors")
        );
        break;
      case "product":
        this.filters.unitOfMeasurement = "spots";
        this.entriesSpots = await SpecialInitiatives.loadProductsTopInvestors(
          this.filtersForAPI("top_investors")
        );
        this.filters.unitOfMeasurement = "seconds";
        this.entriesSeconds = await SpecialInitiatives.loadProductsTopInvestors(
          this.filtersForAPI("top_investors")
        );
        break;
      default:
        this.entriesSpots = [];
        this.entriesSeconds = [];
    }
  }
}
